import React from 'react';
import Providers from '../../Providers';
import { DEFAULT_LOCALE } from '../../i18n';
import {
  CrossPatientIDGWidget,
  CrossPatientIDGWidgetProps,
} from './CrossPatientIDGWidget';

export type CrossPatientIDGProps = CrossPatientIDGWidgetProps & {
  theme?: string | null;
  locale?: keyof mumms.translations;
};

/**
 * Cross-patient IDG entry point for the dashboard.
 * Wraps the widget shell with ThemeProvider / IntlProvider like other apps.
 */
export const CrossPatientIDG = ({
  theme,
  locale = DEFAULT_LOCALE,
  ...widgetProps
}: CrossPatientIDGProps) => (
  <Providers locale={locale} theme={theme}>
    <CrossPatientIDGWidget {...widgetProps} />
  </Providers>
);
